export const sumakomiMap = () => {

  class CustomMap {

    constructor(options = {}) {

      // GMAP Setting
      this.targetId = options.targetId || "map";
      this.lat = options.lat || 34.684257;
      this.lng = options.lng || 135.511053;
      this.zoom = options.zoom || 13;
      this.mapMarkerImg = options.mapMarkerImg || "/wp/wp-content/themes/orikomitry/assets/img/cal/empty-marker.png";
      this.customMapTypeId = 'Custom';

      // Style
      this.saturation = options.saturation || 0;
      this.visibility = options.visibility || 'on';
      this.lightness = options.lightness || 0;
      this.hue = options.hue || '';
      this.gamma = options.gamma || 1;
      this.invertLightness = options.invertLightness || false;

      // Instance
      this.latLng = new google.maps.LatLng(this.lat, this.lng);
      this.mapMarkerIcon = new google.maps.MarkerImage(this.mapMarkerImg);

      this.map = new google.maps.Map(document.getElementById(this.targetId), {
        zoom: this.zoom,
        center: this.latLng,
        mapTypeControlOptions: {
          mapTypeIds: [this.customMapTypeId, google.maps.MapTypeId.ROADMAP],
        },
        fullscreenControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP,
        },
        streetViewControl: false,
        mapTypeControl: false,
      });

      this.customType = new google.maps.StyledMapType([{
        'stylers': [{
          'saturation': this.saturation
        }, {
          'visibility': this.visibility
        }, {
          'lightness': this.lightness
        }, {
          'hue': this.hue
        }, {
          'gamma': this.gamma
        }, {
          'invert_lightness': this.invertLightness
        }]
      }], {
        name: this.styledMapName
      });
      this.map.mapTypes.set(this.customMapTypeId, this.customType);
      this.map.setMapTypeId(this.customMapTypeId);

      this.marker = new google.maps.Marker({
        position: this.latLng,
        map: this.map,
        icon: this.mapMarkerIcon,
      });
    }

    get getMap() {
      return this.map;
    }

    get getMapMarker() {
      return this.marker;
    }

    get getAreaMarkers() {
      return this.markers;
    }
  }

  window.CustomMap = CustomMap;

}